import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Map = (props: Icon): React.ReactElement => (
  <svg
    version="1.1"
    viewBox="0 0 60 60"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <defs>
      <path
        id="map-a"
        d="m17.507 19.587 0.27518 0.062168 17.111 4.8889c1.2981 0.37088 2.0497 1.7238 1.6789 3.0219-0.34439 1.2054-1.5356 1.9396-2.7433 1.7414l-0.27862-0.062503-13.995-4.0004v37.314l14.679 5.7176 18.003-6.7475c0.47413-0.17777 0.98927-0.20308 1.4746-0.076629l0.28702 0.094079 14.445 5.7449v-15.952c0-1.2536 0.94365-2.2868 2.1594-2.428l0.28507-0.016446c1.2536 0 2.2868 0.94365 2.428 2.1594l0.016446 0.28507v19.556c0 1.6313-1.5545 2.7767-3.0794 2.3611l-0.26846-0.089751-16.917-6.7276-17.988 6.7451c-0.45071 0.16899-0.93861 0.20026-1.4028 0.094174l-0.34274-0.10531-17.111-6.666c-0.84498-0.32918-1.4303-1.0946-1.5389-1.979l-0.01825-0.29875v-42.223c0-1.5285 1.3769-2.657 2.8408-2.4126zm39.937-4.9208c9.6491 0 15.889 7.1792 15.889 16.194 0 2.8666-1.5858 6.5838-4.3967 11.196-0.82884 1.3599-1.7537 2.7746-2.7582 4.2298-1.5007 2.1742-3.1044 4.3337-4.708 6.3836l-0.81055 1.0265-1.3421 1.6514-0.04742 0.045553-0.033012 0.04608-0.13113 0.13113-0.04608 0.033012-0.045553 0.04742-0.24723 0.18237-0.1432 0.085847-0.11881 0.061199-0.14523 0.064118-0.27509 0.092266-0.2829 0.058931-0.1392 0.01672-0.14829 0.0085914-0.28884-0.0085914-0.1392-0.01672-0.2829-0.058931-0.27509-0.092266-0.14523-0.064118-0.11881-0.061199-0.1432-0.085847-0.24723-0.18237-0.047998-0.04742-0.043636-0.033012-0.13113-0.13113-0.035456-0.04608-0.044976-0.045553-0.60074-0.73058-1.1386-1.4214c-0.13516-0.17114-0.273-0.34649-0.41332-0.52586-1.6035-2.0499-3.2073-4.2094-4.708-6.3836-1.0045-1.4553-1.9293-2.87-2.7582-4.2298-2.8109-4.6118-4.3967-8.3291-4.3967-11.196 0-9.0153 6.2398-16.194 15.889-16.194zm0 4.8889c-6.7848 0-11 4.8498-11 11.306 0 1.6792 1.3226 4.7795 3.6824 8.6512 0.77764 1.2759 1.6526 2.6142 2.6071 3.9971 1.0802 1.5651 2.2206 3.1283 3.3762 4.6466l1.3343 1.7228 0.17536-0.221c1.1606-1.4837 2.3211-3.0265 3.4365-4.5856l1.0986-1.5629c0.95455-1.383 1.8295-2.7213 2.6071-3.9971 2.3598-3.8717 3.6824-6.972 3.6824-8.6512 0-6.4557-4.2152-11.306-11-11.306zm0 7.3333c1.2536 0 2.2868 0.94365 2.428 2.1594l0.016446 0.30952c0 1.35-1.0944 2.4444-2.4444 2.4444-1.2536 0-2.2868-0.94365-2.428-2.1594l-0.016446-0.30952c0-1.35 1.0944-2.4444 2.4444-2.4444z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-1230 -918)">
        <g transform="translate(556 824)">
          <g transform="translate(0 80)">
            <g transform="translate(660)">
              <mask id="map-b" fill="white">
                <use xlinkHref="#map-a" />
              </mask>
              <g fill={props.color || theme.palette.grey600} mask="url(#map-b)">
                <rect width="88" height="88" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
